import { useMediaQuery } from "@mui/material";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MKBox from "components/MKBox";
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import Counters from "pages/Presentation/sections/Counters";
import Information from "pages/Presentation/sections/Information";
import routes from "routes";
import { Button } from "@mui/material";
import { ReactComponent as DesktopImage } from "assets/images/BANNER-FIC-XVI-2025-Estudiantes-Hz.svg";
import { ReactComponent as MobileImage } from "assets/images/BANNER-FIC-XVI-2025-Estudiantes-Mobile.svg";

function Presentation() {
  const isMobile = useMediaQuery("(max-width:600px)");

  const postData = (e) => {
    e.preventDefault();
    window.location.href = "/registro";
  };

  return (
    <>
      <DefaultNavbar routes={routes} sticky />
      <MKBox
        width="100vw"
        height="auto"
        sx={{
          position: "relative",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          overflow: "hidden",
        }}
      >
        {isMobile ? (
          <MobileImage style={{ width: "100%", height: "auto", maxWidth: "600px" }} />
        ) : (
          <DesktopImage style={{ width: "100%", height: "auto", maxWidth: "100%" }} />
        )}
      </MKBox>
      <Container sx={{ position: "relative", zIndex: 2 }}>
        <Grid container item xs={12} lg={12} justifyContent="center" mx="auto" textAlign="center">
          <Button
            variant="contained"
            color="primary"
            sx={{
              position: "fixed",
              bottom: "20px",
              right: "20px",
              backgroundColor: "#007bff",
              color: "#fff",
              fontSize: "1rem",
              fontWeight: "bold",
              borderRadius: "50px",
              padding: "10px 20px",
              boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
              "&:hover": {
                backgroundColor: "#0056b3",
              },
            }}
            onClick={postData}
          >
            Inscríbete aquí
          </Button>
        </Grid>
      </Container>
      <Card id="information-section">
        <Counters />
        <Information />
      </Card>
    </>
  );
}

export default Presentation;
